import React from 'react'

const Dot = ({className}: {className?: string}) => {
  return <div className={'min-w-1.5 min-h-1.5 rounded-full bg-primary-400 ' + className || ''}></div>
}

export default Dot
